<div class="dom">
  <div class="dom__label">
    <ion-label>{{question.label}}</ion-label>
  </div>

  <div class="input-group">
    <div class="dom__fields">
      <select class="form-control day" [(ngModel)]="question.editingValue" [name]="question.key"
        (ngModelChange)="question.error = null" (blur)="save()" (keydown.enter)="save()" required>
        <option class="dom__option" value="" disabled selected>- Select Day -</option>
        <option class="dom__option" *ngFor="let d of days" [value]="d">{{d}}</option>
      </select>
    </div>
  </div>
</div>